/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAllocateSharedService {

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateDetailByTransactionId(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-detail-by-transaction-id/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardBrokerTradeToolTransferAllocateDetailByTransactionId(
companyId?: string,
transactionId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/broker-trade-tool/transfer-allocate-detail-by-transaction-id',
            query: {
                'companyId': companyId,
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateSharedTransferAllocateDetailByTransactionIdInternal(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate-shared/transfer-allocate-detail-by-transaction-id-internal/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
